
export interface IPlaceHolderService {
    getHeight(size?: string): number
}

class PlaceHolderService implements IPlaceHolderService {

    getHeight(size?: string): number {
        switch (size) {
            case "small":
                return 40;
            case "medium":
                return 70;
            case "large":
                return 100;
            case "xlarge":
                return 175;
            case "xxlarge":
                return 225;
            case "xxxlarge":
                return 300;
            default:
                return 100;
        }
    }
}

export default PlaceHolderService;
